import React, { useImperativeHandle, useRef } from 'react'
import AsyncSelect from 'react-select/async'
import LocationSearchFieldOption from './LocationSearchFieldOption'
import LocationSearchFieldLoadingMessage from './LocationSearchFieldLoadingMessage'
import { FormatOptionLabelMeta, InputActionMeta, KeyboardEventHandler } from 'react-select'

const defaultCustomComponents = {
  DropdownIndicator: null,
  Option: LocationSearchFieldOption,
  LoadingMessage: LocationSearchFieldLoadingMessage,
  LoadingIndicator: null,
  ClearIndicator: null,
}

export interface Props {
  menuIsOpen: boolean;
  className?: string;
  value?: any;
  isClearable?: boolean;
  placeholder?: string;
  customComponents?: any;
  inputValue?: string;
  setValue: any;
  onChange: (changedSearchItem: App.SearchItem | App.AirportLocation, { action }: { action: string }) => void;
  isOptionDisabled?: (option: any) => boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  loadOptions?: (inputValue: string, callback: (options: readonly any[]) => void) => void | Promise<readonly any[]>;
  onInputChange?: (newValue: string, actionMeta: InputActionMeta) => void;
  formatOptionLabel?: (option: any, labelMeta: FormatOptionLabelMeta<any, false>) => React.ReactNode;
  onKeyDown?: KeyboardEventHandler;
  noOptionsMessage: JSX.Element
  autoFocus: boolean;
}

const LocationSearchField = React.forwardRef((props: Props, ref) => {
  const {
    menuIsOpen,
    className,
    value = null,
    isClearable = true,
    placeholder,
    customComponents,
    inputValue,
    setValue,
    onChange,
    isOptionDisabled,
    onFocus,
    onBlur,
    loadOptions,
    onInputChange,
    formatOptionLabel,
    onKeyDown,
    noOptionsMessage,
    autoFocus,
  } = props

  const selectRef = useRef(null)
  useImperativeHandle(ref, () => selectRef.current)

  return (
    <AsyncSelect
      menuIsOpen={menuIsOpen}
      isClearable={isClearable}
      value={value}
      inputValue={inputValue}
      placeholder={placeholder}
      autosize
      className={className}
      components={{ ...defaultCustomComponents, ...customComponents }}
      ref={selectRef}
      inputRef={selectRef}
      setValue={setValue}
      hasError={false}
      classNamePrefix="select-dropdown"
      // Always return null when search.length < 2 to prevent the loading animation from firing
      loadOptions={loadOptions}
      onChange={onChange}
      onInputChange={onInputChange}
      formatOptionLabel={formatOptionLabel}
      isOptionDisabled={isOptionDisabled}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      // @ts-ignore The @types/react-select package has the wrong type for this prop
      noOptionsMessage={() => noOptionsMessage}
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus={autoFocus}
    />
  )
})

export default LocationSearchField
